export default "__VITE_ASSET__DqOtXK3___"